import React from 'react'
import './App.css'
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import LoginPage from './pages/loginPage'
import HomePage from './pages/homePage'
import Page404 from './pages/Page404'

import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { M_Router } from './M_Components'

export default function App() {

  const endpoints = [
    "listUsers",
    "company",
    "booking",
    "bl",
    "transport",
    "shipment",
    "bookingEquipment",
    "Equipment",
    "equipmentType",
    "account",
    "Account",
    "voyage",
    "commodity",
    "dangerousGoods",
    "location",
    "Country"
  ]

  return (
    <M_Router
      primaryColor={'var(--color-blue)'}
      secondaryColor={'var(--color-blue-dark)'}
      tertiaryColor={'var(--color-blue-light)'}
      endpoints={endpoints}
      Routing={
        <Router>
          <Routes>
            {
              localStorage.getItem("tokenMaeil") ?
                <Route path="/" element={<Navigate to="/home" />} />
                :
                <Route path="/" element={<Navigate to="/login" />} />
            }
            <Route
              path="*" element={<Page404 />} />
            <Route
              path="/home/*" element={<HomePage />} />
            <Route
              path="/login" element={<LoginPage />} />
          </Routes>
        </Router>
      }
    />
  )
}